export const APP_NAME = "Agent Harness Tracker";
export const APP_VERSION = "0.4.47";
export const PARSER_VERSION = "aht-codex-rollout-8";
export const SCHEMA_USER_VERSION = 8;
export const PUBLIC_SCHEMA_VERSION = 1 as const;

export const DEFAULT_PORT = 4317;
export const DEFAULT_HOSTNAME = "127.0.0.1";

// Budgets apply to projected metadata, not native image/history payload bytes.
export const DEFAULT_MAX_FILE_BYTES = 512 * 1024 * 1024;
export const DEFAULT_MAX_LINE_BYTES = 4 * 1024 * 1024;
export const API_BODY_LIMIT_BYTES = 64 * 1024;

export const SESSION_TABLE_PAGE_SIZE = 50;
export const COMMAND_PAGE_SIZE = 50;
export const DIAGNOSTIC_LIMIT = 40;
export const REASON_LIMIT = 240;
export const TITLE_MAX = 120;
export const NOTE_MAX = 1000;
export const AREA_MAX = 120;

export const LOCK_FILENAME = "tracker.lock";
export const DB_FILENAME = "tracker.sqlite";

export const SHELL_TOOL_NAMES = new Set([
  "exec_command",
  "exec",
  "shell",
  "local_shell",
  "bash",
  "zsh",
  "sh",
]);

export const COMMIT_SHA_RE = /^(?:[0-9a-f]{40}|[0-9a-f]{64})$/i;
export const SAFE_ID_RE = /^[0-9a-z][0-9a-z._:-]{0,127}$/i;
export const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const EXECUTABLE_RE = /^[A-Za-z0-9._+-]{1,64}$/;

export const CHANGE_CATEGORIES = [
  "model",
  "instructions-skills",
  "tooling",
  "runtime",
  "library-framework",
  "architecture",
  "verification",
  "other",
] as const;
